/* eslint-disable camelcase */
import { assetUrl } from './UrlHelpers';
export var pageJsonLd = function pageJsonLd(_ref) {
  var share = _ref.share,
    header_title = _ref.header_title,
    header_subtitle = _ref.header_subtitle,
    created_at = _ref.created_at,
    updated_at = _ref.updated_at,
    url = _ref.url,
    _ref$author = _ref.author,
    author = _ref$author === void 0 ? 'Balenciaga' : _ref$author,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'en' : _ref$language;
  return {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: share == null ? void 0 : share.title,
    description: share == null ? void 0 : share.description,
    image: share != null && share.image ? assetUrl(share.image, {
      width: 1024
    }) : '',
    url: url,
    headline: "".concat(header_title || '', " ").concat(header_subtitle || ''),
    datePublished: created_at,
    dateModified: updated_at,
    author: author,
    inLanguage: language
  };
};